var render = function render(){var _vm=this,_c=_vm._self._c;return _c('embed',{staticClass:"backImage mx-auto my-3",attrs:{"src":_vm.image,"type":_vm.getEmbedType,"alt":"imagen"}})
}
var staticRenderFns = []

export { render, staticRenderFns }